'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, type FC } from 'react';
import { cx, Modal } from '@endurancewarranty/ui';
import { INITIAL_CENTER_DIALOG_STATE, centerDialogAtom } from '@lib/states/dialogs/centerDialogAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
export const CenterDialog: FC = () => {
  const $ = _c(15);
  const [centerDialogState, setCenterDialogState] = useJotaiAtom(centerDialogAtom);
  const {
    isOpen,
    children,
    size
  } = centerDialogState;
  const isModalOpen = isOpen ?? false;
  const containerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== isModalOpen) {
    t0 = () => {
      if (isModalOpen) {
        containerRef.current?.focus();
      }
    };
    t1 = [isModalOpen];
    $[0] = isModalOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  if (!isModalOpen) {
    return null;
  }
  const t2 = size === "sm";
  const t3 = size === "md";
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = cx("min-h-[150px]", {
      "w-[400px]": t2,
      "w-[550px]": t3
    });
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== setCenterDialogState) {
    t5 = () => setCenterDialogState(INITIAL_CENTER_DIALOG_STATE);
    $[6] = setCenterDialogState;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div ref={containerRef} tabIndex={-1} role="dialog" aria-modal="true" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== centerDialogState.shouldCloseOnBlur || $[10] !== children || $[11] !== isModalOpen || $[12] !== t4 || $[13] !== t5) {
    t7 = <Modal className={t4} isOpen={isModalOpen} shouldCloseOnBlur={centerDialogState.shouldCloseOnBlur} onClose={t5} hasCloseButton={false}>{t6}{children}</Modal>;
    $[9] = centerDialogState.shouldCloseOnBlur;
    $[10] = children;
    $[11] = isModalOpen;
    $[12] = t4;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};